'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DOMSource = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _domEvent = require('@most/dom-event');

var _mostSubject = require('most-subject');

var _isolation = require('./isolate/isolation');

var _EventDelegator = require('./EventDelegator');

var _ElementFinder = require('./ElementFinder');

var _util = require('./util');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function determineUseCapture(eventType, options) {
  var result = false;
  if (typeof options.useCapture === 'boolean') {
    result = options.useCapture;
  }

  if (_util.eventTypesThatDontBubble.indexOf(eventType) !== -1) {
    result = true;
  }

  return result;
}

var DOMSource = exports.DOMSource = function () {
  function DOMSource(rootElement$, namespace, isolateModule, delegators) {
    _classCallCheck(this, DOMSource);

    this._rootElement$ = rootElement$;
    this._namespace = namespace;
    this._isolateModule = isolateModule;
    this._delegators = delegators;
  }

  _createClass(DOMSource, [{
    key: 'select',
    value: function select(selector) {
      if (typeof selector !== 'string') {
        throw new Error('DOM driver\'s select() expects the argument to be a ' + 'string as a CSS selector');
      }

      var trimmedSelector = selector.trim();
      var childNamespace = trimmedSelector === ':root' ? this._namespace : this._namespace.concat(trimmedSelector);

      return new DOMSource(this._rootElement$, childNamespace, this._isolateModule, this._delegators);
    }
  }, {
    key: 'events',
    value: function events(eventType) {
      var _this = this;

      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
      // eslint-disable-line complexity
      if (typeof eventType !== 'string') {
        throw new Error('DOM driver\'s events() expects argument to be a ' + 'string representing the event type to listen for.');
      }
      var useCapture = determineUseCapture(eventType, options);

      var namespace = this._namespace;
      var scope = (0, _util.getScope)(namespace);
      var key = scope ? eventType + '~' + useCapture + '~' + scope : eventType + '~' + useCapture;

      var domSource = this;

      var rootElement$ = void 0;
      if (scope) {
        (function () {
          var hadIsolatedMutable = false;
          rootElement$ = _this._rootElement$.filter(function filterScopedElements(rootElement) {
            var hasIsolated = !!domSource._isolateModule.getIsolatedElement(scope);
            var shouldPass = hasIsolated && !hadIsolatedMutable;
            hadIsolatedMutable = hasIsolated;
            return shouldPass;
          });
        })();
      } else {
        rootElement$ = this._rootElement$.take(2);
      }

      return rootElement$.map(function setupEventDelegators(rootElement) {
        // eslint-disable-line complexity
        if (!namespace || namespace.length === 0) {
          return (0, _domEvent.domEvent)(eventType, rootElement, useCapture);
        }

        var delegators = domSource._delegators;

        var top = scope ? domSource._isolateModule.getIsolatedElement(scope) : rootElement;

        var delegator = void 0;
        if (delegators.has(key)) {
          delegator = delegators.get(key);
          delegator.updateTopElement(top);
        } else {
          delegator = new _EventDelegator.EventDelegator(top, eventType, useCapture, domSource._isolateModule);
          delegators.set(key, delegator);
        }
        var stream = (0, _mostSubject.subject)();

        if (scope) {
          domSource._isolateModule.addEventDelegator(scope, delegator);
        }

        delegator.addDestination(stream, namespace);

        return stream;
      }).switch().multicast();
    }
  }, {
    key: 'dispose',
    value: function dispose() {
      this.isolateModule.reset();
    }
  }, {
    key: 'isolateSource',
    value: function isolateSource(source, scope) {
      return (0, _isolation.isolateSource)(source, scope);
    }
  }, {
    key: 'isolateSink',
    value: function isolateSink(sink, scope) {
      return (0, _isolation.isolateSink)(sink, scope);
    }
  }, {
    key: 'elements',
    get: function get() {
      if (this._namespace.length === 0) {
        return this._rootElement$;
      }

      var elementFinder = new _ElementFinder.ElementFinder(this._namespace, this._isolateModule);

      return this._rootElement$.map(function (el) {
        return elementFinder.call(el);
      });
    }
  }, {
    key: 'namespace',
    get: function get() {
      return this._namespace;
    }
  }]);

  return DOMSource;
}();


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/DOMSource.js
 **/